// Central export for all modals
import AddDocument from './content/AddDocument';
import ApplyEntitlements from './content/ApplyEntitlements';
import ChangePasswordModal from './content/ChangePasswordModal';
import ChangeReportPasswordModal from './content/ChangeReportPasswordModal';
import ConfirmModal from './types/Confirm';
import Disclosures from './content/Disclosures';
import Error from './types/Error';
import FeedbackModal from './content/FeedbackModal';
import ForgotPassword from './content/ForgotPassword';
import IconsKeyModal from './content/IconsKeyModal';
import KibanaCredentials from './content/KibanaCredentials';
import MessageModal from './types/Message';
import Notifications from './content/Notifications';
import OrderMessageModal from './content/OrderMessage';
import PendingReports from './content/PendingReports';
import PrefModal from '../preferences/PrefPanel';
import SecurityPolicy from './content/SecurityPolicy';
import SecuritySearch from './content/SecuritySearch';
import TwoFactorAuth from './content/TwoFactorAuth';
import ViewDocument from './content/ViewDocument';
import ViewReport from './content/ViewReport';
import MenuModal from './types/Menu';
import DocumentDetails from './content/DocumentDetails';
import AccountLocked from './content/AccountLocked';
import ExposureSecuritiesModal from './content/ExposureSecuritiesModal';
import PerformanceSecuritiesModal from './content/PerformanceSecuritiesModal';

const Modals = {
  AddDocument,
  ApplyEntitlements,
  ChangePasswordModal,
  ChangeReportPasswordModal,
  ConfirmModal,
  Disclosures,
  Error,
  FeedbackModal,
  ForgotPassword,
  IconsKeyModal,
  KibanaCredentials,
  MenuModal,
  MessageModal,
  Notifications,
  OrderMessageModal,
  PendingReports,
  PrefModal,
  SecurityPolicy,
  SecuritySearch,
  TwoFactorAuth,
  ViewDocument,
  ViewReport,
  DocumentDetails,
  AccountLocked,
  PerformanceSecuritiesModal,
  ExposureSecuritiesModal,
};

export default Modals;
